import useCampaignStats from 'services/campaign/useCampaignStats';
import useSellingStats from 'services/item/useSellingStats';
import useBoughtSoldStats from 'services/order/useBoughtSoldStats';

export const useMyActivityStats = () => {
  const { myActivitySellingStats, refreshSellingStats: refreshMyActivitySellingStats } = useSellingStats();

  const { myActivityBoughtSoldStats, refreshBoughtSoldStats: refreshMyActivityBoughtSoldStats } = useBoughtSoldStats();

  const { campaignStats, refreshCampaignStats } = useCampaignStats();

  const refresh = () => {
    refreshMyActivitySellingStats();
    refreshMyActivityBoughtSoldStats();
    refreshCampaignStats();
  };

  return {
    myActivitySellingStats,
    myActivityBoughtSoldStats,
    campaignStats,
    refresh,
  };
};
